






















































import { Component, Watch, Vue } from 'vue-property-decorator'
@Component
export default class ProfitListHeader extends Vue {
  private checked: string = '全情報'

  /* computed */
  private get checkedLossFactor () {
    return this.checked
  }
  @Watch('checkedLossFactor')
  onRadioChange (val: string) {
    this.$emit('refine-list', val)
  }
}
